export const scribeEvents = {
  landingPageEvent: 'landing-page-event',
  newExpInitiated: 'new_exp_initiated',
  newExpVariablesComplete: 'new_exp_variables_complete',
  newExpSampleSizeComplete: 'new_exp_sample_size_complete',
  newExpTargetingComplete: 'new_exp_targeting_complete',
  newExpAnalysisComplete: 'new_exp_analysis_complete',
  newExpAnalysisSkipped: 'new_exp_analysis_skipped',
  newExpRequested: 'new_exp_requested',
  newExpRequestFailed: 'new_exp_request_failed',
  newExpWithErrors: 'new_exp_with_errors',
  expSampleSizeBtnClickEvent: 'exp_sample_size_btn_click_event',
  expSampleSizeManualInputEvent: 'exp_sample_size_manual_input_event',
};

export const scribeInstrumentationEvents = {
  viewExperimentPage: {
    name: 'EXPERIMENTS_PAGE.PAGE_VIEW',
    state: 'EXPERIMENTS_PAGE',
  },
  viewNewCalendarPage: {
    name: 'NEW_CALENDAR_PAGE.PAGE_VIEW',
    state: 'NEW_CALENDAR_PAGE',
  },
  viewOldCalendarPage: {
    name: 'OLD_CALENDAR_PAGE.PAGE_VIEW',
    state: 'OLD_CALENDAR_PAGE',
  },
  showExperimentBanner: {
    name: 'EXPERIMENTS_BANNER.EXPERIMENTS_BANNER_SHOWN',
    state: 'EXPERIMENTS_BANNER',
  },

  clickExperimentBannerLink: {
    name: 'DASHBOARD_BANNER.CLICK_EXPERIMENTS_BANNER_LINK',
    state: 'DASHBOARD_BANNER',
  },
  dismissExperimentBanner: {
    name: 'DASHBOARD_BANNER.EXPERIMENTS_BANNER_DISMISS',
    state: 'DASHBOARD_BANNER',
  },
  clickExperimentPageIcon: {
    name: 'EXPERIMENTS_DASH_ICON.CLICK_EXPERIMENTS_DASH_ICON',
    state: 'EXPERIMENTS_DASH_ICON',
  },
  clickCreateExperiment: {
    name: 'EXPERIMENTS_PAGE.CLICK_CREATE_EXPERIMENT',
    state: 'EXPERIMENTS_PAGE',
  },

  clickShowFilterExperiment: {
    name: 'DASHBOARD_FILTER.CLICK_SHOW_FILTERS',
    state: 'DASHBOARD_FILTER',
  },
  clickApplyFilterExperiment: {
    name: 'DASHBOARD_FILTER.CLICK_APPLY_FILTERS',
    state: 'DASHBOARD_FILTER',
  },
  clickClearFilterExperiment: {
    name: 'DASHBOARD_FILTER.CLICK_CLEAR_FILTERS',
    state: 'DASHBOARD_FILTER',
  },

  clickExperimentColumnHeader: {
    name: 'DASHBOARD_COLUMN.CLICK_COLUMN_HEADER',
    state: 'DASHBOARD_COLUMN',
  },
  updateExperimentColumnHeader: {
    name: 'DASHBOARD_COLUMN.COLUMN_UPDATE',
    state: 'DASHBOARD_COLUMN',
  },

  changeExperimentPageNumber: {
    name: 'DASHBOARD_PAGINATION.CLICK_EXPERIMENT_PAGE',
    state: 'DASHBOARD_PAGINATION',
  },
  changeExperimentPageSize: {
    name: 'DASHBOARD_PAGINATION.CLICK_EXPERIMENT_PAGE_ROWS',
    state: 'DASHBOARD_PAGINATION',
  },

  clickExperimentSearch: {
    name: 'DASHBOARD_SEARCH.CLICK_EXPERIMENTS_SEARCH',
    state: 'DASHBOARD_SEARCH',
  },

  clickExperimentDetail: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickExperimentMoreOption: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_MORE',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickCloneExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_CLONE',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickAbortExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_ABORT',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickApproveExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_APPROVE',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickRejectExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_REJECT',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickEditExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_EDIT',
    state: 'DASHBOARD_EXPERIMENT',
  },
  clickPauseExperiment: {
    name: 'DASHBOARD_EXPERIMENT.CLICK_EXPERIMENT_PAUSE',
    state: 'DASHBOARD_EXPERIMENT',
  },
};

export const newCreationFlowEvents = {
  clickTryNewCreationFlowFromHomePage: {
    name: 'CLICK_TRY_NEW_CREATION_FLOW',
    state: 'HOMEPAGE',
  },
  clickTryNewCreationFlowFromOldFlow: {
    name: 'CLICK_TRY_NEW_CREATION_FLOW',
    state: 'OLD_CREATION_FLOW',
  },
  viewCreateExperimentModal: {
    name: 'PAGE_VIEW',
    state: 'CREATE_EXPERIMENT_MODAL',
  },
  clickCreateExperimentModal: {
    name: 'CLICK_CREATE_EXPERIMENT',
    state: 'CREATE_EXPERIMENT_MODAL',
  },
  clickCancelExperimentModal: {
    name: 'CLICK_CANCEL',
    state: 'CREATE_EXPERIMENT_MODAL',
  },
  clickValidate: {
    name: 'CLICK_VALIDATE',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  viewReviewModal: {
    name: 'EXPERIMENT_REVIEW_MODAL',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  submitReviewModal: {
    name: 'EXPERIMENT_REVIEW_MODAL_SUBMIT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  cancelReviewModal: {
    name: 'EXPERIMENT_REVIEW_MODAL_CANCEL',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickEditTreatment: {
    name: 'CLICK_EDIT_TREATMENT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickDeleteTreatment: {
    name: 'CLICK_DELETE_TREATMENT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickAddTreatment: {
    name: 'CLICK_ADD_TREATMENT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickAddVariable: {
    name: 'CLICK_ADD_VARIABLE',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  selectAssignmentStrategy: {
    name: 'SELECT_ASSIGNMENT_STRATEGY',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickSplitEvenly: {
    name: 'CLICK_SPLIT_EVENLY',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  changeTimesliceValue: {
    name: 'CHANGE_TIMESLICE_VALUE',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  changeTimesliceUnit: {
    name: 'CHANGE_TIMESLICE_UNIT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickSwitchToOldFlow: {
    name: 'CLICK_SWITCH_TO_OLD_FLOW',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
  clickEditExperiment: {
    name: 'CLICK_EDIT_EXPERIMENT',
    state: 'CREATE_EXPERIMENT_FLOW',
  },
};

export const newVariablesEvents = {
  clickSearchByConstraints: {
    name: 'CLICK_SEARCH_BY_CONSTRAINTS',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickCreateVariable: {
    name: 'CLICK_CREATE_VARIABLE',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickFinishTour: {
    name: 'CLICK_FINISH_TOUR',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickCloseTour: {
    name: 'CLICK_CLOSE_TOUR',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickVariableRow: {
    name: 'CLICK_VARIABLE_ROW',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickEditVariable: {
    name: 'CLICK_VIEW_VARIABLE',
    state: 'NEW_VARIABLE_PAGE',
  },
  clickVariableRollout: {
    name: 'CLICK_VARIABLE_ROLLOUT',
    state: 'NEW_VARIABLE_PAGE',
  },
};

export const searchByConstraintsEvents = {
  pageView: {
    name: 'PAGE_VIEW',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  selectFacet: {
    name: 'SELECT_FACET',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  selectValue: {
    name: 'SELECT_VALUE',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  removeSearch: {
    name: 'REMOVE_SEARCH',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  addSearch: {
    name: 'ADD_SEARCH',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  useSearchBox: {
    name: 'USE_SEARCH_BOX',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  clickFilter: {
    name: 'CLICK_FILTER',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  clickRolloutTarget: {
    name: 'CLICK_ROLLOUT_TARGET',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  hoverRolloutTarget: {
    name: 'HOVER_ROLLOUT_TARGET',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
  clickPageNumber: {
    name: 'CLICK_PAGE_NUMBER',
    state: 'SEARCH_BY_CONSTRAINTS',
  },
};

export const variableSettingsEvents = {
  pageView: {
    name: 'PAGE_VIEW',
    state: 'VARIABLE_SETTINGS',
  },
  createVariable: {
    name: 'CREATE_VARIABLE',
    state: 'VARIABLE_SETTINGS',
  },
  saveVariable: {
    name: 'SAVE_VARIABLE',
    state: 'VARIABLE_SETTINGS',
  },
};

export const axaScorecardEvents = {
  visitTab: {
    name: 'AXA_SCORECARD.VISIT_TAB',
    state: 'AXA_SCORECARD',
  },
  clickExpandMetric: {
    name: 'AXA_SCORECARD.CLICK_EXPAND_METRIC',
    state: 'AXA_SCORECARD',
  },
  clickDownloadQuery: {
    name: 'AXA_SCORECARD.CLICK_DOWNLOAD_QUERY',
    state: 'AXA_SCORECARD',
  },
  clickViewFullResults: {
    name: 'AXA_SCORECARD.CLICK_VIEW_FULL_RESULTS',
    state: 'AXA_SCORECARD',
  },
};
